/*
 * PAWS & PEARLS — SECRET SKY ROOF & TERRACE BIRD v1.1 — ARTWORK VERTICAL ALIGNMENT
 * Jeeves XXVI | 27 October 2026 | MAGICAL MUSE WORLD (unpublished duplicate)
 *
 * Approved concept: one tiny silent black/ivory/rose-gold bird perches at the
 * P&P roof, flies down to the terrace balustrade, looks around, flutters only
 * a little to the right, returns in an arc and rests before repeating.
 *
 * INDEPENDENT ADDITIVE LAYER ONLY. Does not edit/manage Muse's balloon,
 * the four departing balloons, seven distant balloons, five bird flocks,
 * Lilla, five miniature zebras, hippo, audio, pearl shower or scroll/camera.
 * Uses exactly the approved four House-bird perch assets + seven flight assets.
 * No wing/body art is invented; animation is distinct frame changes + movement.
 * Coordinates are proportional to the 1122 x 1402 TOP-ALIGNED accepted artwork.
 */
(function(){
  'use strict';
  var SKY_ID='pp-muse-secret-sky';
  var CONFIG_ID='pp-muse-roof-terrace-bird-assets';
  var LAYER_ID='pp-muse-roof-terrace-bird-v1';
  var STYLE_ID=LAYER_ID+'-style';
  var NS='ppMuseRoofTerraceBirdV1';
  var SOURCE_W=1122, SOURCE_H=1402;
  var LOOP_SECONDS=32.0;
  var instances=[];
  var VERSION='1.1-rendered-artwork-y-coordinate-fix';

  function pct(x,y){return {x:x/SOURCE_W*100,y:y/SOURCE_H*100};}
  var ROOF=pct(223,192), TERRACE=pct(304,353), RIGHT=pct(348,347);
  function clamp(v){return Math.max(0,Math.min(1,v));}
  function ease(v){v=clamp(v);return v*v*(3-2*v);}
  function bez(a,b,c,d,t){
    var q=1-t;
    return {
      x:q*q*q*a.x+3*q*q*t*b.x+3*q*t*t*c.x+t*t*t*d.x,
      y:q*q*q*a.y+3*q*q*t*b.y+3*q*t*t*c.y+t*t*t*d.y
    };
  }
  function path(a,b,c,d,v){return bez(a,b,c,d,ease(v));}
  function f(n){return 'f'+(n<10?'0':'')+n;}
  function getFrame(t,phaseStart){return f(Math.floor(Math.max(0,t-phaseStart)*8)%7+1);}

  /* The first 15.2 seconds follow the accepted V2 animation study.
     The rest of each 32-second circuit remains perched on the roof. */
  function poseAt(sec){
    var t=((sec%LOOP_SECONDS)+LOOP_SECONDS)%LOOP_SECONDS;
    var a,u,p;
    if(t<2.55){
      return {phase:'roof-perch',point:ROOF,key:t<1.6?'p03':t<2.1?'p02':'p04',flying:false,flip:false};
    }
    if(t<5.00){
      u=(t-2.55)/2.45;
      return {phase:'descending-to-terrace',point:path(ROOF,pct(278,137),pct(367,247),TERRACE,u),key:getFrame(t,2.55),flying:true,flip:false};
    }
    if(t<7.00){
      a=t-5;
      return {phase:'terrace-look',point:TERRACE,key:a<.7?'p02':a<1.2?'p04':a<1.65?'p03':'p01',flying:false,flip:false};
    }
    if(t<8.15){
      u=(t-7)/1.15;
      return {phase:'small-right-flutter',point:path(TERRACE,pct(319,338),pct(334,330),RIGHT,u),key:getFrame(t,7),flying:true,flip:false};
    }
    if(t<9.30){
      a=t-8.15;
      return {phase:'right-hand-pause',point:RIGHT,key:a<.45?'p02':a<.9?'p03':'p04',flying:false,flip:false};
    }
    if(t<12){
      u=(t-9.3)/2.7;
      return {phase:'return-to-roof',point:path(RIGHT,pct(392,300),pct(270,118),ROOF,u),key:getFrame(t,9.3),flying:true,flip:true};
    }
    a=t-12;
    return {phase:'roof-rest',point:ROOF,key:a<.8?'p03':a<1.35?'p02':'p03',flying:false,flip:false};
  }

  function getAssets(){
    var holder=document.getElementById(CONFIG_ID);
    if(!holder)return null;
    var d=holder.dataset||{}, map={}, keys=[];
    for(var j=1;j<=4;j++)keys.push('p0'+j);
    for(var k=1;k<=7;k++)keys.push('f0'+k);
    for(var i=0;i<keys.length;i++){
      var key=keys[i],url=d[key];
      if(typeof url!=='string'||!(/^(https?:\/\/|\/)/.test(url))){
        console.warn('[P&P Roof Bird] Missing asset URL '+key+'; no bird will be added.');
        return null;
      }
      map[key]=url;
    }
    return map;
  }

  function ensureStyles(){
    if(document.getElementById(STYLE_ID))return;
    var node=document.createElement('style');
    node.id=STYLE_ID;
    node.textContent=[
      'html.pp-muse-secret-sky-page #'+SKY_ID+' #'+LAYER_ID+'{',
      'position:absolute!important;inset:0!important;z-index:2!important;',
      'pointer-events:none!important;overflow:hidden!important;user-select:none!important;}',
      'html.pp-muse-secret-sky-page #'+LAYER_ID+' .pp-roof-terrace-bird-actor{',
      'position:absolute!important;left:0;top:0;display:block!important;',
      'width:3.65%;height:auto!important;max-width:none!important;',
      'pointer-events:none!important;user-select:none!important;-webkit-user-drag:none!important;',
      'transform-origin:center center!important;will-change:left,top,transform;}',
      '@media(max-width:767px){html.pp-muse-secret-sky-page #'+LAYER_ID+'{display:none!important;}}'
    ].join('');
    document.head.appendChild(node);
  }

  function preload(assets){
    var keys=Object.keys(assets);
    return Promise.all(keys.map(function(k){
      return new Promise(function(resolve,reject){
        var im=new Image();
        im.onload=function(){resolve(im);};
        im.onerror=function(){reject(new Error('Could not load '+k));};
        im.src=assets[k];
        if(im.complete&&im.naturalWidth)resolve(im);
      });
    }));
  }

  function remove(inst){
    if(inst.raf){cancelAnimationFrame(inst.raf);inst.raf=0;}
    if(inst.io)inst.io.disconnect();
    if(inst.layer&&inst.layer.isConnected)inst.layer.remove();
    document.removeEventListener('visibilitychange',inst.onVisibility);
    inst.ended=true;
  }
  function display(inst,p){
    if(p.key!==inst.lastKey){inst.img.src=inst.assets[p.key];inst.lastKey=p.key;}
    inst.img.style.left=p.point.x.toFixed(4)+'%';
    // Critical Safari/Shopify correction: the tall 1122x1402 backdrop is
    // displayed with background-size:100% auto and background-position:center top.
    // The sky container can be shorter than that displayed image. Its height
    // MUST NOT be used to convert the bird's source-image Y coordinates.
    // Keep artwork-relative X as percentage of sky width; convert Y to pixels
    // using the ACTUAL displayed backdrop width (full image is scaled by width).
    // This keeps roof/rail precisely attached to the existing drawing.
    var artworkScale=(inst.sky.getBoundingClientRect().width||inst.sky.clientWidth)/SOURCE_W;
    var sourceY=(p.point.y/100)*SOURCE_H;
    inst.img.style.top=(sourceY*artworkScale).toFixed(2)+'px';
    inst.img.style.transform='translate(-50%,-58%)'+(p.flip?' scaleX(-1)':'');
    // A very small change between flying and perching only. Never a foreground-sized bird.
    inst.img.style.width=(p.flying?'3.8%':'3.65%');
    inst.phase=p.phase;
  }
  function schedule(inst){
    if(inst.ended||inst.raf||!inst.ready||!inst.visible||document.hidden||inst.reduced)return;
    inst.raf=requestAnimationFrame(function(now){tick(inst,now);});
  }
  function tick(inst,now){
    inst.raf=0;
    if(inst.ended||!inst.layer.isConnected||!inst.visible||document.hidden||inst.reduced){inst.lastNow=0;return;}
    if(inst.lastNow){inst.elapsed+=Math.min(Math.max(now-inst.lastNow,0),100);}
    inst.lastNow=now;
    display(inst,poseAt(inst.elapsed/1000));
    schedule(inst);
  }
  function attach(){
    if(!document.documentElement.classList.contains('pp-muse-secret-sky-page'))return;
    var sky=document.getElementById(SKY_ID),wrapper=document.querySelector('.page-wrapper');
    if(!sky||!wrapper||!wrapper.contains(sky))return;
    if(document.getElementById(LAYER_ID))return;
    var assets=getAssets();if(!assets)return;
    ensureStyles();
    var layer=document.createElement('div');layer.id=LAYER_ID;layer.setAttribute('aria-hidden','true');
    var img=document.createElement('img');img.className='pp-roof-terrace-bird-actor';
    img.alt='';img.draggable=false;img.decoding='async';img.loading='eager';
    img.style.visibility='hidden';
    layer.appendChild(img);sky.appendChild(layer);
    var inst={sky:sky,layer:layer,img:img,assets:assets,ready:false,reduced:false,
              visible:false,elapsed:0,lastNow:0,raf:0,io:null,lastKey:'',phase:'preloading',ended:false};
    inst.reduced=!!(window.matchMedia&&window.matchMedia('(prefers-reduced-motion:reduce)').matches);
    inst.onVisibility=function(){if(document.hidden){inst.lastNow=0;}else schedule(inst);};
    document.addEventListener('visibilitychange',inst.onVisibility);
    instances.push(inst);
    preload(assets).then(function(){
      if(inst.ended)return;
      inst.ready=true;
      display(inst,poseAt(0));
      inst.img.style.visibility='visible';
      // Passive background life begins only once the actual Secret Sky enters view.
      if('IntersectionObserver' in window){
        inst.io=new IntersectionObserver(function(entries){
          var e=entries[0];
          inst.visible=!!(e&&e.isIntersecting);
          if(!inst.visible){inst.lastNow=0;if(inst.raf)cancelAnimationFrame(inst.raf);inst.raf=0;}
          else schedule(inst);
        },{threshold:0.01});
        inst.io.observe(inst.sky);
      }else{inst.visible=true;schedule(inst);}
    }).catch(function(err){
      console.warn('[P&P Roof Bird] Asset preloading failed. Leaving the Secret Sky untouched.',err);
      remove(inst);
    });
  }
  function onUnload(ev){
    for(var i=instances.length-1;i>=0;i--){
      var inst=instances[i];
      if(ev.target&&(ev.target===inst.sky||ev.target.contains(inst.sky))){remove(inst);instances.splice(i,1);}
    }
  }
  window[NS]={
    version:VERSION,
    getStatus:function(){
      var a=instances.filter(function(v){return !v.ended;})[0];
      return {present:!!(a&&a.layer.isConnected),ready:!!(a&&a.ready),
        phase:a?a.phase:'not-mounted',visible:!!(a&&a.visible),
        loopSeconds:LOOP_SECONDS,sourceArtwork:'approved House bird poses and flight frames',
        path:'roof > terrace > short right flutter > roof',
        positionMapping:'source-image Y scaled to rendered backdrop width (not sky-container height)',
        changesExistingFlight:false};
    }
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',attach,{once:true});
  else attach();
  document.addEventListener('shopify:section:load',attach);
  document.addEventListener('shopify:section:unload',onUnload);
  window.addEventListener('pageshow',attach);
})();
